export const LOCATION_TYPES = [
  "RECEPTION",
  "REGULAR",
  "PICKING",
  "DAMAGED",
  "BULK",
  "LOST"
]
